import React from 'react';
import { Folder, Tv } from 'lucide-react';

export const GPOVALLAS_FOLDER_ICONS: Record<string, React.ReactNode> = {
  'auto-resolution': <Tv size={12} />,
  'auto-resolution-branded': <Tv size={12} />
};

export const getGPOVALLASFolderIcon = (sk: string): React.ReactNode => {
  return GPOVALLAS_FOLDER_ICONS[sk] || <Folder size={12} />;
};
